import { useState } from 'react';
import { useReportContext } from '../report-context';
import { format } from 'date-fns';
import { DietitianAvatarIcon } from '@snapi/icons';
import { PlayIcon } from '@snapi/icons';
import { Subtitle } from '@snapi/luxury';
import Modal from 'react-modal';
import { CloseIcon } from '@snapi/icons';

const vimeoEmbedCode = `
<iframe src="https://player.vimeo.com/video/855317690?h=311c3a185d&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" width="100%" height="100%" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" title="Demo_video"></iframe>`;

const numberOfGoodAsText = (number: number) => {
  if (number < 2) {
    return 'could use some improvement';
  } else if (number < 4) {
    return 'development is on track';
  }
  return 'health is impressive';
};
interface ReportHeaderHeroProps {
  reportedAt: string | null;
  numberOfGood: number;
}

export const ReportHeaderHero: React.FC<ReportHeaderHeroProps> = ({
  reportedAt,
  numberOfGood,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };
  const { baby } = useReportContext();

  return (
    <div className="container py-10 lg:flex lg:gap-9 xl:gap-7">
      <h5 className="mb-3 sm:hidden">
        sample from
        <span className="ml-[2px]">
          {format(new Date(reportedAt || Date.now()), 'MMMM dd, yyyy')}
        </span>
      </h5>
      <h1 className="mb-5 sm:mb-[40px] lg:basis-1/2 lg:mb-0">
        <span className="text-white">{baby.name}'s</span>{' '}
        {numberOfGoodAsText(numberOfGood)}
      </h1>
      <div className="sm:flex flex-wrap items-start lg:basis-1/2">
        <div className="flex items-center gap-3 sm:gap-4 mb-3 sm:mb-2 lg:items-start">
          <div className="shrink-0">
            <DietitianAvatarIcon />
          </div>
          <div>
            <h5 className="sm:mb-2">Personal Dietitian</h5>
            <p className="font-semibold hidden sm:block mb-3">
              Hi! I'm Dana, and I'm here to help you better understand what's
              happing in {baby.name}'s gut. Let's get started!
            </p>

            <div className="">
              <div
                className="gap-2 items-center hidden sm:flex"
                onClick={openModal}
              >
                <PlayIcon /> <Subtitle>Demo Video</Subtitle>
              </div>
              <Modal
                isOpen={isModalOpen}
                onRequestClose={closeModal}
                contentLabel="Video Modal"
                ariaHideApp={false}
                style={{
                  overlay: {
                    backgroundColor: 'rgba(0, 0, 0, 0.7)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 1000,
                  },
                  content: {
                    width: '80%',
                    maxWidth: '800px',
                    height: '80%',
                    maxHeight: '100%',
                    border: 'none',
                    borderRadius: '10px',
                    overflow: 'hidden',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    zIndex: 1001,
                  },
                }}
              >
                <div
                  onClick={closeModal}
                  className='absolute top-0 right-0 mt-3 mr-3 cursor-pointer"'
                >
                  <CloseIcon />
                </div>
                <div dangerouslySetInnerHTML={{ __html: vimeoEmbedCode }} />
              </Modal>
            </div>
          </div>
        </div>
        <div className="sm:hidden">
          <p className="font-semibold mb-3">
            Hi! I'm Dana, and I'm here to help you better understand what's
            happing in {baby.name}'s gut. Let's get started!
          </p>
          <div>
            <div className="gap-2 items-center flex" onClick={openModal}>
              <PlayIcon /> <Subtitle>Demo Video</Subtitle>
            </div>
            <Modal
              isOpen={isModalOpen}
              onRequestClose={closeModal}
              contentLabel="Video Modal"
              ariaHideApp={false}
              style={{
                overlay: {
                  backgroundColor: 'rgba(0, 0, 0, 0.7)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  zIndex: 1000,
                },
                content: {
                  width: '80%',
                  maxWidth: '800px',
                  height: '80%',
                  maxHeight: '100%',
                  border: 'none',
                  borderRadius: '10px',
                  overflow: 'hidden',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  zIndex: 1001,
                },
              }}
            >
              <div
                onClick={closeModal}
                className='absolute top-0 right-0 mt-3 mr-3 cursor-pointer"'
              >
                <CloseIcon />
              </div>
              <div
                dangerouslySetInnerHTML={{ __html: vimeoEmbedCode }}
                className="w-full h-full"
              />
            </Modal>
          </div>
        </div>
      </div>
    </div>
  );
};
